/**
 * Страницы предмета (07-оболочка-тз, «Страницы предмета — состояния»).
 *
 * Многостраничная вещь — учебник, папка, инструкция — остаётся одним предметом:
 * страницы это обычные секции того же файла с `- page: N`. Заголовок секции
 * хранит состояние и попадает в сейв, число задаёт только порядок — поэтому
 * номер можно переставить, не ломая сохранение.
 *
 * Здесь лежат те несколько слов, которые движок произносит сам. Их приходится
 * зашивать в код по той же причине, по которой зашиты служебные команды:
 * `осмотреть` и `листать` не объявлены ни в одной заметке, их создаёт оболочка.
 */

/** Глагол, на который отвечают страницы. Он же дефолтный генератор комнаты. */
export const EXAMINE = 'осмотреть';

/** Глагол листания. В метке он не появляется: внутри книги листают книгу. */
export const LEAF = 'листать';

/**
 * Метки внутри книги. Имя предмета в них не нужно: пока предмет открыт, список
 * коротко говорит, что можно сделать с ним, и ни с чем другим команды не спорят.
 */
export const FORWARD = 'вперёд';
export const BACK = 'назад';

/**
 * Выход из чтения. Называется `закрыть`, а не `назад`, ровно из-за соседства:
 * два «назад» подряд в списке глазами не различаются.
 */
export const CLOSE = 'закрыть';

/**
 * `tag: screen` — предмет, у которого есть свой экран (07-оболочка-тз, «Предмет,
 * у которого есть свой экран»).
 *
 * Контейнер открывает уровень окнами, книга — страницами, а вещь с одним
 * ответом и собственным действием до сих пор не открывала его ничем: действие
 * было написано и недостижимо. Тег — авторское «этот осмотр и есть вход
 * в вещь»; движок его не угадывает по числу секций.
 */
export const SCREEN = 'screen';

export function closeLabel(item: string): string {
  return `${CLOSE} ${item}`;
}
